(function ($) {
  $(function () {
    // I only have one form on the page but you can be more specific if need be.
    const $form = $(".mc-embedded-subscribe-form");

    if ($form.length > 0) {
      $('.mc-embedded-subscribe-form input[type="submit"]').on(
        "click",
        function (event) {
          if (event) event.preventDefault();
          register($form);
        }
      );
    }
  });

  function register($form) {
    $.ajax({
      type: $form.attr("method"),
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "json",
      contentType: "application/json; charset=utf-8",
      error: function () {
        $form.find(".mce-responses .response").text("Oups...An error occured.");
      },
      success: function (data) {
        $form.find(".mce-responses .response").text(data.msg);
      },
    });
  }
})(jQuery);
